import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { syndEnum } from '@bingads-webui-campaign-react/constants';

// Does not support campaign type specific localization
const getLocalizationMapping = (adDistribution) => {
  switch (adDistribution) {
    case syndEnum.BingYahooOnly:
      return _TL_('Microsoft sites and select traffic');
    case syndEnum.SearchPartnersOnly:
      return _TL_('Only partner traffic');
    case syndEnum.BingYahooAndSearchPartners:
    default:
      return _TL_('The entire Microsoft Advertising Network (recommended)');
  }
};

export const AdDistribution = ({ adDistribution }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Ad distribution') }}>
      <Text>{i18n.getString(getLocalizationMapping(adDistribution))}</Text>
    </PropertyRow>
  );
};

AdDistribution.propTypes = {
  adDistribution: PropTypes.string.isRequired,
};
